import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApplicationInsightsService {
  private appInsights?: ApplicationInsights;

  constructor() {
    const instrumentationKey = environment.appInsightsKey?.trim();

    if (!instrumentationKey) {
      return;
    }

    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey,
        enableAutoRouteTracking: true,
      },
    });
    this.scheduleAppInsightsLoad();
  }

  private scheduleAppInsightsLoad(): void {
    const load = () => this.appInsights?.loadAppInsights();

    if (typeof requestIdleCallback === 'function') {
      requestIdleCallback(load);
      return;
    }

    setTimeout(load, 0);
  }

  setAuthenticatedUserContext(userName: string, accountId: string) {
    this.appInsights?.setAuthenticatedUserContext(userName, accountId);
  }

  logPageView(userName?: string, uri?: string) {
    let name = userName;
    this.appInsights?.trackPageView({ name, uri });
  }

  logEvent(name: string, properties?: { [key: string]: any }) {
    this.appInsights?.trackEvent({ name: name }, properties);
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any }) {
    this.appInsights?.trackMetric({ name: name, average: average }, properties);
  }

  logException(exception: Error, severityLevel?: number) {
    this.appInsights?.trackException({ exception: exception, severityLevel: severityLevel });
  }

  logTrace(message: string, severity?: string, properties?: { [key: string]: any }) {
    this.appInsights?.trackTrace({ message: message }, properties);
  }
}
